"use strict";

/* A service / model */
_BannerFlowApp.factory("History", function (AuthInfo, Cookie, $location) {
    return {
        getHistory: function () {
            return new HistoryObject().deserialize(window.localStorage.getItem("history"));
        },
        saveHistory: function (history) {
            window.localStorage.setItem("history", history.serialize());
        },
        GetLastVisitedBrand: function () {
            var history = this.getHistory();
            return history.lastVisitedBrand;
        },
        SetLastVisitedBrand: function (view) {
            var brand = AuthInfo.LoggedInUser.currentBrand;
            var history = this.getHistory();
            var brandId = AuthInfo.LoggedInUser.currentBrand.id;

            history.setLastVisitedBrand(brandId, brand.name, $location.$$path);

            //Save last location as cookie, so backend can do redirects correctly
            Cookie.Create("lastBrand", brandId);

            if (view) {
                Cookie.Create("lastView", view);
            }

            this.saveHistory(history);
        },
        AddVisitedObject: function (id, name, image, type) {
            var history = this.getHistory();
            var brandId = AuthInfo.LoggedInUser.currentBrand.id;

            history.addObjectActivity(brandId, {
                id: id,
                name: name,
                image: image,
                type: type
            });

            this.saveHistory(history);
        },
        GetVisitedObjects: function () {
            var history = this.getHistory();
            var id = AuthInfo.LoggedInUser.currentBrand.id;

            return history.getLatestObjectsForBrand(id);
        }
    };
});

function HistoryObject() {
    this.lastVisitedBrand = null;
    this.activity = [];

    this.setLastVisitedBrand = function (brandId, brandName, path) {
        this.lastVisitedBrand = {
            name: brandName,
            path: path,
            brandId: brandId
        };

        var brand = _.find(this.activity, function (a) {
            return a.brandId === brandId;
        });

        if (brand) {
            brand.count += 1;
        } else {
            this.activity.push({
                brandId: brandId,
                count: 1,
                objects: []
            });
        }

        //Clean up if too many brands in activity list
        this.cleanUpActivity(brandId);
    };

    this.addObjectActivity = function (brandId, object) {
        var brand = _.find(this.activity, function (a) {
            return a.brandId === brandId;
        });

        if (brand) {
            var existingObject = _.find(brand.objects, function (o) {
                return o.id === object.id;
            });

            //If object already exists in the list remove the old object
            if (existingObject) brand.objects.splice(brand.objects.indexOf(existingObject), 1);

            brand.objects.unshift(object);

            //Keep the object list max 5 items long
            if (brand.objects.length > 5) {
                brand.objects.pop();
            }
        } else {
            this.activity.push({
                brandId: brandId,
                count: 0,
                objects: [object]
            });
        }

        //Clean up if too many brands in activity list
        this.cleanUpActivity(brandId);
    };

    this.getLatestObjectsForBrand = function (brandId) {
        if (!this.activity) return [];

        var brand = _.find(this.activity, function (a) {
            return a.brandId === brandId;
        });

        if (brand) return brand.objects;
        else return [];
    };

    this.cleanUpActivity = function (brandId) {
        if (this.activity.length > 20) {
            var oldestVisitedBrand = _.sortBy(
                _.filter(this.activity, function (a) {
                    return a.brandId != brandId;
                }),
                function (a) {
                    return a.count;
                }
            )[0];
            this.activity.splice(this.activity.indexOf(oldestVisitedBrand), 1);
        }
    };

    this.deserialize = function (json) {
        var history = JSON.parse(json) || {};

        this.lastVisitedBrand = history.b
            ? {
                  name: history.b.n,
                  path: history.b.p,
                  brandId: history.b.bid
              }
            : null;

        this.activity = history.a
            ? history.a.map(function (activity) {
                  return {
                      brandId: activity.bi,
                      count: activity.c || 0,
                      objects: activity.o
                          ? activity.o.map(function (object) {
                                return {
                                    id: object.i,
                                    name: object.n,
                                    image: object.im,
                                    type: object.t
                                };
                            })
                          : []
                  };
              })
            : [];

        return this;
    };

    this.serialize = function () {
        return JSON.stringify({
            b: this.lastVisitedBrand
                ? {
                      n: this.lastVisitedBrand.name,
                      p: this.lastVisitedBrand.path,
                      bi: this.lastVisitedBrand.brandId
                  }
                : {},
            a: this.activity.map(function (activity) {
                return {
                    bi: activity.brandId,
                    c: activity.count,
                    o: activity.objects.map(function (object) {
                        return {
                            i: object.id,
                            n: object.name,
                            im: object.image,
                            t: object.type
                        };
                    })
                };
            })
        });
    };
}
